export const types = {
  PAYLOAD: "PAYLOAD",
  VERIFICATIONSCRIPT:"VERIFICATIONSCRIPT",
  POST: "POST"
}